var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#C4CDFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 30.0005H25.8333V25.798C25.8327 25.1447 25.5728 24.5183 25.1109 24.0563C24.6489 23.5943 24.0225 23.3345 23.3692 23.3338H16.6308C15.9775 23.3345 15.3511 23.5943 14.8891 24.0563C14.4272 24.5183 14.1673 25.1447 14.1667 25.798V30.0005H12.5V25.798C12.5013 24.7028 12.937 23.6529 13.7113 22.8785C14.4857 22.1041 15.5357 21.6685 16.6308 21.6672H23.3692C24.4643 21.6685 25.5142 22.1041 26.2886 22.8785C27.063 23.6529 27.4987 24.7028 27.5 25.798V30.0005Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 19.9999C19.011 19.9999 18.0443 19.7067 17.2221 19.1573C16.3998 18.6079 15.759 17.827 15.3805 16.9134C15.0021 15.9997 14.9031 14.9944 15.096 14.0245C15.2889 13.0546 15.7651 12.1637 16.4644 11.4644C17.1637 10.7652 18.0546 10.2889 19.0245 10.096C19.9944 9.90309 20.9997 10.0021 21.9134 10.3805C22.827 10.759 23.6079 11.3998 24.1573 12.2221C24.7067 13.0443 24.9999 14.011 24.9999 14.9999C24.9986 16.3256 24.4714 17.5966 23.534 18.534C22.5966 19.4714 21.3256 19.9986 19.9999 19.9999V19.9999ZM19.9999 11.6666C19.3407 11.6666 18.6962 11.8621 18.148 12.2284C17.5999 12.5947 17.1726 13.1152 16.9203 13.7243C16.6681 14.3334 16.602 15.0036 16.7307 15.6502C16.8593 16.2969 17.1767 16.8908 17.6429 17.357C18.1091 17.8231 18.703 18.1406 19.3496 18.2692C19.9962 18.3978 20.6665 18.3318 21.2756 18.0795C21.8846 17.8273 22.4052 17.4 22.7715 16.8518C23.1378 16.3037 23.3333 15.6592 23.3333 14.9999C23.3333 14.1159 22.9821 13.268 22.357 12.6429C21.7318 12.0178 20.884 11.6666 19.9999 11.6666Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.2e01ead299b4867c619de20870745a52.svg";
export { ForwardRef as ReactComponent };